import client from './client';

export const getProviderOrganizationsApi = ({ providerId }) =>
  client().get('/organization-providers', {
    params: { providerId },
  });
